import { takeEvery } from 'redux-saga/effects'

import { TOGGLE_MAP_VIEW } from '../actions'
import { toggleMapViewInDOM } from '../helpers'

/**
 * Switching to map view mode and back on XS screens.
 */
export default function* mapViewSaga() {
    // @ts-ignore
    yield takeEvery(TOGGLE_MAP_VIEW, action => toggleMapViewInDOM(action.active))
}
